import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

// Each word in its own span, inside the element it was in, so the highlight keeps its color.
const wrapWords = (node) => {
	for (const child of [...node.childNodes]) {
		if (child.nodeType !== Node.TEXT_NODE) {
			wrapWords(child);
			continue;
		}

		const words = document.createDocumentFragment();

		for (const part of child.textContent.split(/(\s+)/)) {
			if (/^\s*$/.test(part)) {
				words.append(part);
			} else {
				const word = document.createElement('span');
				word.className = 'word';
				word.textContent = part;
				words.append(word);
			}
		}

		child.replaceWith(words);
	}
};

export default function (section) {
	const title = section.querySelector('h2');

	wrapWords(title);

	// The words light up one after another while the title crosses the screen; done before it reaches the middle, where the Nosotros link leaves it.
	gsap.fromTo(title.querySelectorAll('.word'), { opacity: 0.15 }, {
		opacity: 1,
		ease: 'none',
		stagger: 0.1,
		scrollTrigger: {
			trigger: title,
			start: 'top 90%',
			end: 'bottom 65%',
			scrub: true,
		},
	});
}
